/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APICustomerAutocompleteSuggestion
 */
export interface APICustomerAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APICustomerAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APICustomerAutocompleteSuggestion
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APICustomerAutocompleteSuggestion
     */
    ustId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APICustomerAutocompleteSuggestion
     */
    contactNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APICustomerAutocompleteSuggestion
     */
    contactEmails?: Array<string>;
}

/**
 * Check if a given object implements the APICustomerAutocompleteSuggestion interface.
 */
export function instanceOfAPICustomerAutocompleteSuggestion(value: object): value is APICustomerAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APICustomerAutocompleteSuggestionFromJSON(json: any): APICustomerAutocompleteSuggestion {
    return APICustomerAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APICustomerAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APICustomerAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'ustId': json['ust_id'] == null ? undefined : json['ust_id'],
        'contactNames': json['contact_names'] == null ? undefined : json['contact_names'],
        'contactEmails': json['contact_emails'] == null ? undefined : json['contact_emails'],
    };
}

export function APICustomerAutocompleteSuggestionToJSON(value?: APICustomerAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'ust_id': value['ustId'],
        'contact_names': value['contactNames'],
        'contact_emails': value['contactEmails'],
    };
}

